import { DatePicker, LocalizationProvider } from "@mui/lab";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import {
  Box,
  Button,
  CircularProgress,
  Grid,
  Modal,
  Stack,
  TextField,
  Typography
} from "@mui/material";
import moment from "moment";
import React, { useState } from "react";
import { captureCityStockAmountApi } from "src/api/commonapi";
import { notification } from "src/utils/messages";

export default function WalletStatusChangeModal({
  walletStatusChangeModal,
  toggleWalletStatusChangeModal,
  rowData,
  handleCityWiseWalletList
}) {
  const user = JSON.parse(localStorage.getItem("userData"));
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 500,
    bgcolor: "background.paper",
    boxShadow: 10,
    borderRadius: "10px",
    p: 2
  };

  const [isLoading, setIsLoading] = useState(false);

  const [captureData, setCaptureData] = useState({
    capture_date: new Date(),
    amount: rowData.amount,
    u_id: rowData.u_id,
    c_s_w_id: rowData.c_s_w_id
  });
  const [loader, setLoader] = useState(false);
  const [fileimage, setfileimage] = useState();

  const handleCaptureAmount = async () => {
    setLoader(true);
    let fdata = new FormData();
    Object.keys(captureData).forEach((key) => {
      if (key === "capture_date") {
        fdata.append(
          "capture_date",
          captureData.capture_date !== "DD-MM-YYYY"
            ? moment(captureData.capture_date).format("DD-MM-YYYY")
            : captureData.capture_date
        );
      } else {
        fdata.append(key, captureData[key]);
      }
    });
    if (
      captureData.amount == undefined ||
      captureData.amount == 0 ||
      captureData.p_invoice == undefined
    ) {
      let notify = notification({
        type: "error",
        message: "Please Fill Required Fields"
      });
      notify();
    } else {
      setIsLoading(true);
      const resp = await captureCityStockAmountApi(fdata);
      setIsLoading(false);
      let notify = notification({
        type: resp.status == 0 ? "error" : "success",
        message: resp.message
      });
      notify();
      if (resp.status != 0) {
        setCaptureData({
          capture_date: new Date(),
          amount: "",
          u_id: rowData.u_id,
          c_s_w_id: rowData.c_s_w_id
        });
        toggleWalletStatusChangeModal();
        setfileimage();
        handleCityWiseWalletList();
      }
    }
    setLoader(false);
  };
  return (
    <Modal
      open={walletStatusChangeModal}
      onClose={() => toggleWalletStatusChangeModal()}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Typography
          id="modal-modal-title"
          variant="h6"
          component="h2"
          style={{ marginBottom: "5px", textAlign: "center" }}
        >
          Capture Amount
        </Typography>
        <hr />
        <Stack style={{ marginBottom: "15px", marginTop: "20px" }}>
          <Grid container spacing={1}>
            <Grid item sm={12} xs={12} md={12} lg={12}>
              <Stack spacing={3} style={{ marginBottom: "15px", marginTop: "15px" }}>
                {/* <label style={{ marginBottom: '10px' }}>Join Date</label> */}
                <LocalizationProvider
                  dateAdapter={AdapterDateFns}
                  isDisabled
                  style={{ marginTop: "15px" }}
                >
                  <DatePicker
                    type="date"
                    required
                    name="capture_date"
                    label="Date"
                    value={
                      captureData.capture_date
                        ? moment(captureData.capture_date).toDate()
                        : new Date()
                    }
                    inputFormat="dd/MM/yyyy"
                    onChange={(newDate) => {
                      setCaptureData({
                        ...captureData,
                        capture_date: moment(newDate).format("YYYY-MM-DD")
                      });
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        sx={{
                          "& .MuiInputBase-root": {
                            height: 40
                          },
                          "& .MuiInputLabel-root": {
                            top: "-6px" // adjust this to move label vertically
                          }
                        }}
                      />
                    )}
                  />
                </LocalizationProvider>
              </Stack>
            </Grid>

            <Grid item xs={12}>
              {captureData?.p_invoice && (
                <p style={{ margin: "5px 0", fontSize: "14px", fontWeight: 500 }}>
                  {captureData.p_invoice.name}
                </p>
              )}
              <Button variant="contained" component="label">
                Upload Invoice
                <input
                  id="file"
                  name="p_invoice"
                  type="file"
                  hidden
                  onChange={async (event) => {
                    setCaptureData({
                      ...captureData,
                      p_invoice: event.currentTarget.files[0]
                    });
                    setfileimage(URL.createObjectURL(event.currentTarget.files[0]));
                  }}
                  className="form-control"
                />
              </Button>
            </Grid>
            <Grid
              item
              sm={12}
              xs={12}
              style={{
                display: "flex",
                justifyContent: "end",
                alignItems: "center"
              }}
            >
              <Button
                variant="outlined"
                onClick={() => toggleWalletStatusChangeModal()}
                style={{ marginTop: "15px", marginRight: "15px" }}
              >
                Close
              </Button>
              <Button
                variant="contained"
                style={{ marginTop: "15px" }}
                onClick={() => !loader && handleCaptureAmount()}
                disabled={isLoading}
                startIcon={isLoading && <CircularProgress size={20} color="inherit" />}
              >
                Submit
              </Button>
            </Grid>
          </Grid>
        </Stack>
      </Box>
    </Modal>
  );
}
